<template>
  <div style="width: 100%;height: 100%;background-color: white">
    <div style="padding-top:20px;height: calc(100% - 20px);width: 100%;overflow-y: auto" v-loading="loading" element-loading-text="加载中，请耐心等待。">
      <el-row style="height: 100%;">
        <el-col :span="4" style="height: 100%;overflow-y: auto">
          <div style="margin: 0 20px;height: 50px">
            <el-input prefix-icon="el-icon-search" placeholder="输入搜索组织" v-model="filterText" clearable></el-input>
          </div>
          <div style="margin: 0 20px;">
            <el-tree class="filter-tree" show-checkbox :data="treeData" :props="defaultProps" node-key="id" :default-expanded-keys="expandedKeys"
                     :default-checked-keys="isFirst" @check-change="handleCheckChange" :filter-node-method="filterNode" ref="treeData">
            </el-tree>
          </div>
        </el-col>
        <el-col :span="20" style="height: 100%;overflow-y: auto">
          <div style="height: 50px;">
            <span>&nbsp;关键词：</span>
            <el-input size="small" prefix-icon="el-icon-search" placeholder="输入姓名搜索" v-model="sendData.lessname" style="width: 140px"></el-input>
            <span>&nbsp;性别：</span>
            <el-select v-fixZoom size="small" v-model="sendData.sex" filterable placeholder="请选择" :clearable="true" style="width:90px;" >
              <el-option v-for="item in selectSexArr" :key="item.index" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span>&nbsp;频率：</span>
            <el-select v-fixZoom size="small" v-model="sendData.frequency_id" filterable placeholder="请选择" :clearable="true" style="width:120px;" >
              <el-option v-for="item in frequencys" :key="item.index" :label="item.frequency" :value="item.id"></el-option>
            </el-select>
            <span>&nbsp;项目：</span>
            <el-select v-fixZoom size="small" v-model="sendData.project_id" filterable placeholder="请选择" :clearable="true" style="width:140px;" >
              <el-option v-for="item in projects" :key="item.index" :label="item.projectname" :value="item.id"></el-option>
            </el-select>
            <el-button size="small" icon="el-icon-search" type="primary" plain @click="searchWord()">查询</el-button>
          </div>
          <div style="max-height: calc(100% - 110px);overflow-y: auto;">
            <el-table v-loading="tableloading" element-loading-text="加载中，请耐心等待。" :data="tableData"
              border highlight-current-row ref="singleTable">
              <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                min-width="60"
                align="center">
              </el-table-column>
              <el-table-column
                label="性别"
                width="50"
                align="center">
                <template slot-scope="scope">
                  <span>{{getSex(scope.row.sex)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="birthday"
                label="出生日期"
                min-width="85"
                align="center">
              </el-table-column>
              <el-table-column
                prop="phone"
                label="电话号码"
                min-width="85"
                align="center">
              </el-table-column>
              <el-table-column
                prop="orglevelname"
                label="所属区域"
                min-width="70"
                align="center">
              </el-table-column>
              <el-table-column
                prop="h_address"
                label="家庭地址"
                min-width="90"
                align="center">
              </el-table-column>
              <el-table-column
                label="服务频率"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                  <span>{{getFrequencyName(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="所属项目"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                  <span>{{getProjectName(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="timelist"
                label="接听时间段"
                min-width="90"
                align="center">
              </el-table-column>
              <el-table-column
                prop="circumstances"
                label="特殊情况"
                min-width="70"
                align="center">
              </el-table-column>
              <el-table-column
                label="生命体征"
                min-width="70"
                align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.is_dead === 0">在世</span>
                  <span v-if="scope.row.is_dead === 1">离世</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" width="110">
                <template slot-scope="scope">
                  <el-button size="small" type="success" @click="callChange(scope.row)">发起服务</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div style="text-align: center;margin-top: 10px;height: 40px;">
            <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog :visible.sync="orderShow" v-if="orderShow" width="1250px" :show-close="true" :close-on-click-modal="false"
      center top="8vh" class="all-open">
      <div class="title-top-alarm">
        <div><span>派单详情</span></div>
        <div class="line-title"></div>
      </div>
      <send-order :orderObj="orderObj" v-model="orderShow"></send-order>
    </el-dialog>
  </div>
</template>

<script>
import {queryorg} from '../../api/organizer'
import {searcholdpersonwithnewtype} from '../../api/custormservice'
import {queryfrequency, queryproject} from '../../api/serviceObject'
import sendOrder from './childComponents/sendOrder'
export default {
  name: 'activeService',
  components: {sendOrder},
  data () {
    return {
      supplierorg: [],
      types: [],
      newTypes: [],
      supplierTree: [], // 服务商（派单）
      selectSexArr: [{id: 0, name: '女'}, {id: 1, name: '男'}],
      frequencys: [],
      projects: [],
      loading: false,
      // 左边
      orgData: [],
      searchKeyword: '',
      filterText: '',
      treeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      expandedKeys: [],
      isFirst: [],
      // 右边
      sendData: {
        lessname: '',
        sex: '',
        frequency_id: '',
        project_id: ''
      },
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableloading: false,
      tableData: [],
      oids: '',
      // 派单弹窗
      orderShow: false,
      orderObj: {
        projects: [],
        frequencys: [],
        oldperson: '',
        orgData: []
      }
    }
  },
  created () {
    this.getOrgData()
  },
  watch: {
    filterText (val) {
      this.$refs.treeData.filter(val)
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    handleCheckChange () {
      this.currentPage = 1
      this.isFirst = this.$refs.treeData.getCheckedKeys()
      // console.log(this.isFirst)
      this.getAllTableData()
    },
    // 组织
    getOrgData () {
      this.expandedKeys = []
      this.treeData = []
      this.loading = true
      queryorg().then(res => {
        this.orderObj.orgData = this.clone(res.data.org)
        // this.getFrequency()
        this.orgData = res.data.org
        for (let i = 0; i < this.orgData.length; i++) {
          if (this.orgData[i].orgpid === -1) {
            this.expandedKeys.push(this.orgData[i].id)
          }
        }
        // 所属组织
        let lastLevel = 100
        const arr = res.data.org
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level < lastLevel) {
            lastLevel = arr[i].level
          }
        }
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].level === lastLevel) {
            this.treeData.push(arr[i])
          }
        }
        for (let i = 0; i < this.treeData.length; i++) {
          const child = this.arrayToNode1(arr, this.treeData[i].id)
          if (child.length !== 0) {
            this.treeData[i].child = child
          }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
      this.getFrequency()
    },
    // 递归
    arrayToNode1 (nodesArray, pid) {
      const vm = this
      return nodesArray.filter(value => {
        if (value.orgpid === pid) {
          const arrayToNode = vm.arrayToNode1(nodesArray, value.id)
          if (arrayToNode.length > 0) {
            value.child = arrayToNode
          }
          return value
        }
      })
    },
    // 右边 全部查询
    getAllTableData () {
      if (!this.loading) {
        this.tableloading = true
      }
      let data = {
        oids: this.isFirst,
        lessname: this.sendData.lessname,
        sex: this.sendData.sex,
        frequency_id: this.sendData.frequency_id,
        project_id: this.sendData.project_id
      }
      if (data.sex === '') {
        data.sex = -1
      }
      if (data.frequency_id === '') {
        data.frequency_id = -1
      }
      if (data.project_id === '') {
        data.project_id = -1
      }
      searcholdpersonwithnewtype(data, this.currentPage, this.pageSize).then(res => {
        this.tableData = res.data.persons
        this.totalCells = res.data.cnt
        this.loading = false
        this.tableloading = false
      }).catch(() => {
        this.loading = false
        this.tableloading = false
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.getAllTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.getAllTableData()
    },
    // 查询频率
    getFrequency () {
      this.loading = true
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryfrequency(data).then(res => {
        this.frequencys = res.data.frequencys
        this.orderObj.frequencys = this.frequencys
        this.getProjects()
      }).catch(() => {
        this.loading = false
      })
    },
    // 查询项目
    getProjects () {
      let data = {
        orgid: this.$store.state.user.orgid
      }
      queryproject(data).then(res => {
        this.getAllTableData()
        this.projects = res.data.projects
        this.orderObj.projects = this.projects
      }).catch(() => {
        this.loading = false
      })
    },
    searchWord () {
      this.currentPage = 1
      this.getAllTableData()
    },
    getSex (sex) {
      return this.util.getSex(sex + '')
    },
    getFrequencyName (row) {
      for (let i = 0; i < this.frequencys.length; i++) {
        if (row.frequencyid === this.frequencys[i].id) {
          return this.frequencys[i].frequency
        }
      }
    },
    getProjectName (row) {
      let projectname = ''
      if (row.projectids !== null && row.projectids !== '' && row.projectids.length > 0) {
        for (let i = 0; i < row.projectids.length; i++) {
          if (projectname === '') {
            projectname = this.getProject2(row.projectids[i])
          } else {
            projectname = projectname + ',' + this.getProject2(row.projectids[i])
          }
        }
      } else {
        for (let i = 0; i < this.projects.length; i++) {
          if (row.projectid === this.projects[i].id) {
            projectname = this.projects[i].projectname
          }
        }
      }
      return projectname
    },
    getProject2 (id) {
      let projectname = ''
      for (let i = 0; i < this.projects.length; i++) {
        if (id === this.projects[i].id) {
          projectname = this.projects[i].projectname
        }
      }
      return projectname
    },
    callChange (row) {
      this.orderObj.oldperson = row
      this.orderShow = true
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/activeService.vue